module.exports = __webpack_public_path__ + "img/icon-safari.d3380667.svg";